import {api} from '../../api/common.js'
import {serverApi} from '../../api/serverAPI'
import {serverlessApi} from '../../api/serverlessAPI'
import { api as reportsApi} from '../../api/reportsAPI.js'

const datas = {
  getOrders: (args) => new Promise((resolve, reject) => {
    console.log(args)
    api.post('tc-orders/filter?status=fullyPaid&limit=' + args.limit + '&skip=' + args.skip + '&orderBy=' + args.orderBy + '&orderDirection=' + args.orderDirection)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getOrder: (args) => new Promise((resolve, reject) => {
    console.log(args)
    api.get('/tc-orders/' + args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        console.log('Error', error)
        reject(error)
      })
  }),
  getOrderByTransactionId: (args) => new Promise((resolve, reject) => {
    console.log(args)
    api.get('/tc-orders/filter?transactionReference=' + args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getCustomersFiltered: ({
    ...args
  }) => new Promise((resolve, reject) => {
    console.log('getCustomersFiltered', args)
    api.get('/users/selectSearch?' + args.property + '=' + args.value + '&limit=50')
      .then(function (response) {
        resolve(response.data.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createOrder: (args) => new Promise((resolve, reject) => {
    console.log('createOrder', args)
    serverApi.post('/orders/create', {
      customer_id: args.userId,
      product_price_label: args.currency
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  addProduct: (args) => new Promise((resolve, reject) => {
    console.log('addProduct', args)
    serverApi.post('/orders/add_product', {
      order_id: args.order_id,
      product_id: args.product_id,
      classroom_id: args.classroom_id,
      relative_order_bought_product_id: args.relative_order_bought_product_id
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  addDiscount: (args) => new Promise((resolve, reject) => {
    console.log('addDiscount', args)
    serverApi.post('/orders/add_discount', {
      order_id: args.order_id,
      discount_code: args.discount_code
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createCert: (args) => new Promise((resolve, reject) => {
    console.log(args)
  
           serverApi.post('/certificates/saveCertUrl',{obp_id:args.boughtProducts[0].id})
           .then((result) => {

            console.log(result)
            resolve(result)
           })
    
     //save the cert url in the obp
  
  }),
 resendBooking: (args) => new Promise((resolve, reject) => {
  
    serverApi.post('/sendmail/resendBooking', {
      order_id: args.order_id,
      discount_code: args.discount_code
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  sendPartial: (args) => new Promise((resolve, reject) => {
  
    serverApi.post('/sendmail/sendPartial', {
      obp_id: args.obp_id,

    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  applyExtension: (args) => new Promise((resolve, reject) => {
    console.log(args)
    serverApi.post('/extensions/extend_new', {order_bought_product_id: args.obpid, extension_product_id: args.extid})
    .then((result) => {
      console.log(result)
      resolve(result)
    })
    .catch((error) => {
      reject(error)
    })
  }),
  removeDiscount: (args) => new Promise((resolve, reject) => {
    console.log('removeDiscount', args)
    serverApi.post('/orders/remove_discount', {
      order_id: args.order_id
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  removeProduct: (args) => new Promise((resolve, reject) => {
    console.log('addProduct', args)
    serverApi.post('/orders/remove_product', {
      order_id: args.order_id,
      product_id: args.product_id
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  deleteBooking: (args) => new Promise((resolve, reject) => {
    console.log(args)
    api.post('/tc-orders/' + args.orderId + '/delete')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  saveTransaction: (args) => new Promise((resolve, reject) => {
    let order_id = args.orderId
    let amount = Number(args.transaction.amount)
    let description = args.transaction.detail
    serverApi.post('/orders/add_external_payment', {
        order_id: order_id,
        amount: amount,
        description: description
      })
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  updateExpiry: (args) => new Promise((resolve, reject) => {
    let order_bought_product_id = args.order_bought_product_id
    let product_expiry = args.product_expiry
    serverApi.post('/orders/set_product_expiry', {
        order_bought_product_id: order_bought_product_id,
        product_expiry: product_expiry
      })
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  removeExternalPayment: (args) => new Promise((resolve, reject) => {
    let order_id = args.orderId
    let id = Number(args.id)
    serverApi.post('/orders/remove_external_payment', {
        order_id: order_id,
        id: id
      })
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  loginAsCustomer: (username) => new Promise((resolve, reject) => {
    serverApi.post('/auth/login-as', username)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  unenrol: (args) => new Promise((resolve, reject) => {
    console.log(args)
    serverlessApi.post('/order/deleted/')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  removeAttendee: (args) => new Promise((resolve, reject) => {
    console.log(args)
    serverApi.post('/orders/removeAttendee/')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  changeClassroom: (args) => new Promise((resolve, reject) => {
    console.log(args)
    serverApi.post('/orders/changeClassroom/',{customer_id:args.customer_id,obp_id:args.obpId,oldClassroomId:args.oldId,newClassroomId:args.newId,order_id:args.order_id}).then(function (response) {
        console.log('ok')
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getLocationsByDays: (days) => new Promise((resolve, reject) => {
    console.log(days)
    serverApi.get('/classroom/days/' + days)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  }),
  setExpiry: (args) => new Promise((resolve, reject) => {
   
    serverApi.post('/orders/set_product_expiry',{order_id:args.order_id,product_expiry:args.product_expiry})
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
 
}
export default datas


// WEBPACK FOOTER //
// ./src/components/Orders/api.js